import { regenerateToken } from 'lib/api';

export const regenerateJwtToken = async ({ setJwt }: any): Promise<void> => {
  const response = await regenerateToken().catch(err => err);
  if (response instanceof Error) {
    return;
  }

  setJwt(response.accessToken);
};
